const ColorPicker = ({
    value,
    onChange,
    label,
}) => {

    return (

        <div>

            <label>

                {label}

            </label>

            <input
                type="color"
                value={value}
                onChange={(e) => onChange(e.target.value)}
            />

        </div>

    );

};

export default ColorPicker;